<template>
  <div style="height:100vh;overflow: hidden;">
    <div v-if="showMask && ['word','ppt','excel'].includes(fileType)" :class="['mask', fileType=='word'?'mask-white':'']"></div>
    <iframe v-if="frameUrl" :src="frameUrl" id="player" width="100%" height="100%" frameborder="0" @load="onFrameLoaded"></iframe>
  </div>
</template>

<script>
export default {
    name: 'FileView',
    data(){
      return{
        url: '',
        frameUrl: '',
        fileType: '',
        showMask: false
      }
    },
    created(){
      if(this.$route.query.url){
        this.url = decodeURIComponent(atob(this.$route.query.url))
        // this.url = decodeURIComponent(this.$route.query.file)
      }else{
        alert('参数错误')
      }
    },
    mounted(){
      if(this.url.endsWith('ppt') || this.url.endsWith('pptx')){
        this.frameUrl = 'https://view.officeapps.live.com/op/embed.aspx?wdHideControls=true&src=' + encodeURIComponent(this.url)
        this.fileType = 'ppt'
      }else if(this.url.endsWith('doc') || this.url.endsWith('docx')){
        this.frameUrl = 'https://view.officeapps.live.com/op/embed.aspx?wdHideControls=true&src=' + encodeURIComponent(this.url)
        this.fileType = 'word'
      }else if(this.url.endsWith('xls') || this.url.endsWith('xlsx')){
        this.frameUrl = 'https://view.officeapps.live.com/op/embed.aspx?wdHideControls=true&src=' + encodeURIComponent(this.url)
        this.fileType = 'excel'
      }else{
        // this.frameUrl = '/preview/onlinePreview?url=' + this.$route.query.file
        this.frameUrl = this.url
        this.fileType = 'other'
      }
      console.log(this.fileType);
    },
    methods:{
      onFrameLoaded(){
        this.showMask = true
      }
    }
}
</script>

<style scoped>
.mask{
  position: absolute;
  height: 20px;
  width: 100px;
  background: #444444;
  bottom: 2px;
  right: 0;
}
.mask-white{
  width: 90px;
  background: #ffffff;
}
</style>